module.exports = __webpack_public_path__ + "static/media/33.36e0e7c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/33.wav
// module id = mzGt
// module chunks = 0